module.exports = __webpack_public_path__ + "img/img-35.590d1012.png";